let globalId = 0;
export const nextId = () => globalId++;
